import { _api } from './apiAxios';
const api = '';
import store from '@/store';
export function getComparisons(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/comparison/${payload.id}/getcomparisons`);
}
export function getMatches(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/match/${payload.id}/getmatches`);
}
export function getCards(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/card/${payload.id}/getcards`);
}
export function getScorers(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/scorer/${payload.id}/getscorers`);
}
export function getStandings(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/standing/${payload.id}/getstandings`);
}
export function getStatics(payload) {
  return _api.get(`${api}/statscore/${payload.selectedLang}/statistic/${payload.id}/getstatistics`);
}
